// extracted by mini-css-extract-plugin
export default {"base":"AccountCreated_base__xGXn5","image":"AccountCreated_image__elrZ9","text":"AccountCreated_text__UG9Ul","link":"AccountCreated_link__0+378"};